import './vote.css'
import { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Desktop from './components/desktop'
import Mobile from './components/mobile'
import Modal from '../modal/modal'
import image from '../../assets/Birth_of_Io_FA.png'

const Vote3 = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div className='movie__vote' id="movie__vote3">
            <Modal
                show={show}
                handleClose={handleClose}
            />
            <Container>
                <Row className='align-items-center'>
                    <Col lg={6} md={6} xs={12} className="d-flex align-items-center justify-content-center">
                        <div className="make__movie__img">
                            <div className="make__movie__img__scale animation__2">
                                <img src={image} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} md={6} xs={12} className="pl__md5">
                        <Desktop
                            title={'Vote On The Process'}
                            description={'Proident voluptate ex ut minim non. Fugiat esse deserunt sint deserunt enim sint occaecat.'}
                            handleShow={handleShow}
                        />
                        <Mobile
                            title={'Vote On The Process'}
                            description={'Proident voluptate ex ut minim non. Fugiat esse deserunt sint deserunt enim sint occaecat.'}
                            handleShow={handleShow}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Vote3